import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../utilities/props.js";
import getHeightStyles from "../../styles/height/index.js";
import s from "./Icon.module.css";
const Icon = (props) => {
    const { svg: Component, className, color, size = "1em", autoWidth, attributes } = props;
    const heightStyles = getHeightStyles(size);
    const rootClassName = classNames(s.root, className, heightStyles?.classNames, color && s[`--color-${color}`], autoWidth && s["--auto"]);
    const icon = React.isValidElement(Component) ? Component : _jsx(Component, {});
    const style = { ...attributes?.style, ...heightStyles?.variables };
    return (
    // All icons are decorative, a11y attributes should be set for buttons wrapping them
    _jsx("span", { ...attributes, "aria-hidden": "true", className: rootClassName, style: style, children: React.cloneElement(icon, { focusable: false }) }));
};
Icon.displayName = "Icon";
export default Icon;
